// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1j_lvt","shine-lines":"xHLEeV"};